import { ReactNode } from 'react'
import { Table as MuiTable, TableContainer, Box, TableProps as MuiTableProps, styled } from '@mui/material'

const TableWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 1
}))

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  overflowX: 'auto',
  paddingRight: theme.spacing(0.4),
  width: '100%',

  '&::-webkit-scrollbar': {
    height: theme.spacing(0.75)
  },
  [theme.breakpoints.down('lg')]: {
    width: '100%'
  },
  [theme.breakpoints.up('lg')]: {
    paddingBottom: theme.spacing(0.5)
  }
}))

const StyledMuiTable = styled(MuiTable, {
  shouldForwardProp: (prop) => prop !== 'rowExpanded'
})<{
  rowExpanded?: boolean
}>(({ rowExpanded, theme }) => ({
  tableLayout: 'fixed',
  marginBottom: theme.spacing(0.5),

  '& th, & td': {
    padding: theme.spacing(1, 1.25),
    '&:first-of-type': {
      paddingLeft: theme.spacing(1)
    },
    '&:last-child': {
      paddingRight: theme.spacing(1)
    }
  },
  [theme.breakpoints.up('sm')]: {
    '& th, & td': {
      '&:last-child': {
        paddingRight: '0 !important'
      }
    }
  },
  [theme.breakpoints.down('lg')]: {
    minWidth: theme.spacing(75)
  },

  ...(!rowExpanded && {
    '& th, & td': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    }
  })
}))

interface TablePros extends MuiTableProps {
  children?: ReactNode
  label?: string
  rowExpanded?: boolean
}
// TODO: progresive remove the use of this component in favor of the MUI Table
//  https://app.shortcut.com/cartoteam/story/326874/remove-custom-table-component-in-cloud-native
function Table({ children, label, rowExpanded, ...props }: TablePros) {
  return (
    <TableWrapper>
      <StyledTableContainer>
        <StyledMuiTable aria-label={label} rowExpanded={rowExpanded} style={{ tableLayout: 'auto' }} {...props}>
          {children}
        </StyledMuiTable>
      </StyledTableContainer>
    </TableWrapper>
  )
}

export default Table
